var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscover4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4165 4.25C15.035 4.25 11.792 5.5933 9.40089 7.98439C7.0098 10.3755 5.6665 13.6185 5.6665 17H1.4165L6.92734 22.5108L7.0265 22.7092L12.7498 17H8.49984C8.49984 11.5175 12.934 7.08333 18.4165 7.08333C23.899 7.08333 28.3332 11.5175 28.3332 17C28.3332 22.4825 23.899 26.9167 18.4165 26.9167C15.6823 26.9167 13.2032 25.7975 11.4182 23.9983L9.4065 26.01C10.5872 27.1972 11.9912 28.1389 13.5376 28.7808C15.084 29.4227 16.7422 29.7521 18.4165 29.75C21.798 29.75 25.041 28.4067 27.4321 26.0156C29.8232 23.6245 31.1665 20.3815 31.1665 17C31.1665 13.6185 29.8232 10.3755 27.4321 7.98439C25.041 5.5933 21.798 4.25 18.4165 4.25ZM16.9998 11.3333V18.4167L23.0632 22.015L24.0832 20.3008L19.1248 17.3542V11.3333H16.9998Z",
    fill: "#B22539"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover4);
export default __webpack_public_path__ + "static/media/discover4.009381142e6fb6500862063cd3479d9f.svg";
export { ForwardRef as ReactComponent };